<template>
  <div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />

    <form class="default-form" @submit.prevent="submit">
      <h3 class="mb-4">Dados de pagamento</h3>
      <div class="d-flex mb-5">
        <div class="col-12 col-lg-4 me-4">
          <label class="required form-label">Método de pagamento</label>
          <select
            class="form-select"
            v-model.trim="form.payment_method"
            :disabled="invoice.payment_status === 'PAID'"
          >
            <option value="BOLETO">Boleto</option>
            <option value="DEPOSIT">Depósito</option>
          </select>
        </div>
        <div class="col-12 col-lg-3">
          <label class="required form-label">Prazo de pagamento</label>
          <DateTimeInput
            v-model.trim="form.payment_expiration_date"
            format="dd/MM/yyyy"
            type="date"
            theme="basic"
            class="w-100"
            :min="true"
            :disabled="invoice.payment_status === 'PAID'"
          />
        </div>
        <div class="col-12 col-lg-3 me-4">
          <label class="required form-label">Valor do pagamento</label>
          <Money
            class="form-control mb-3"
            v-model.trim="form.amount"
            v-bind="money"
            :disabled="invoice.payment_status === 'PAID'"
          />
        </div>
      </div>
      <h3 class="mb-4">Dados da nota fiscal</h3>
      <div class="d-flex mb-5">
        <div class="col-12 col-lg-2 me-4">
          <label class="required form-label">Emitir nota</label>
          <select
            class="form-select"
            v-model.trim="should_issue_nfse"
            :disabled="invoice.nfse_status === 'ISSUED'"
          >
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </div>
        <div class="col-12 col-lg-3 me-4">
          <label class="required form-label">Valor da nota</label>
          <Money
            class="form-control mb-3"
            v-model.trim="form.nfse_amount"
            v-bind="money"
            :disabled="invoice.nfse_status === 'ISSUED'"
          />
        </div>
      </div>
      <template v-if="should_issue_nfse === 'S'">
        <div class="d-flex mb-5">
            <div class="col-12 col-lg-2 me-4">
              <label class="required form-label">Billing profile</label>
              <select
                class="form-select"
                v-model.trim="form.billing_profile"
                :disabled="invoice.nfse_status === 'ISSUED'"
              >
                <option value="ADVERTISER">Anunciante</option>
                <option value="COMPANY">Empresa</option>
              </select>
            </div>
            <div class="col-12 col-lg-3 me-4">
              <label class="required form-label">Data de emissão da nota</label>
              <DateTimeInput
                v-model.trim="form.nfse_issuance_date"
                format="dd/MM/yyyy"
                type="date"
                theme="basic"
                class="w-100"
                :disabled="invoice.nfse_status === 'ISSUED'"
              />
            </div>
            <div class="col-12 col-lg-6">
              <div class="">
                <label class="form-label">Descrição da NF</label>
                <textarea v-model="form.nfse_description" class="form-control" rows="2" :disabled="invoice.nfse_status === 'ISSUED'"></textarea>
              </div>
            </div>
        </div>
        <div class="d-flex mb-5">
          <div class="col-12 col-lg-4 me-4">
            <label class="form-label">Nota fiscal manual</label>
            <input type="file" @change="changeNFSeFile" class="form-control" :disabled="invoice.nfse_status === 'ISSUED'" />
          </div>
          <div class="col-12 col-lg-4 me-4" v-if="form.nfse_file">
            <label class="required form-label">Número da nota fiscal</label>
            <input type="text" class="form-control" :disabled="invoice.nfse_status === 'ISSUED'" v-model.trim="form.nfse_number" />
          </div>
        </div>
      </template>
      <div class="text-center">
        <Button
          class="btn btn-primary me-4"
          @click="submit"
          :loading="loader"
        >
          Editar
        </Button>
        <Button
          class="btn btn-danger"
          @click="cancel"
        >
          Cancelar
        </Button>
      </div>
    </form>
  </div>
</template>

<script>

import OrdersService from '@/modules/orders/services/orders-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import DateTimeInput from '@/components/common/Input/DateTimeInput'
import { Money } from 'v-money'

export default {
  name: 'EditOrderForm',
  props: ['order'],
  components: {
    AlertWraper,
    Button,
    DateTimeInput,
    Money
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      form: {
        amount: 0,
        billing_profile: '',
        nfse_amount: 0,
        nfse_description: '',
        nfse_issuance_date: '',
        nfse_file: null,
        nfse_number: '',
        payment_expiration_date: '',
        payment_method: '',
        should_issue_nfse: false
      },
      loader: false,
      localOrder: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      should_issue_nfse: 'S'
    }
  },
  created () {
    this.localOrder = this.order
    this.form.amount = this.order.amount / 100
    this.form.billing_profile = this.invoice.billing_profile
    this.form.nfse_description = this.invoice.nfse_description
    this.form.nfse_issuance_date = this.invoice.nfse_issuance_date
    this.form.nfse_amount = this.invoice.nfse_amount / 100
    this.form.payment_method = this.invoice.payment_method
    this.should_issue_nfse = this.invoice.should_issue_nfse ? 'S' : 'N'
    if (this.invoice.payment_method === 'BOLETO') this.form.payment_expiration_date = this.invoice.boleto_expiration_date
    else if (this.invoice.payment_method === 'DEPOSIT') this.form.payment_expiration_date = this.invoice.deposit_expiration_date
  },
  computed: {
    /**
     * Get invoice
    */
    invoice () {
      return this.localOrder.invoices[0]
    }
  },
  methods: {
    /**
     * Cancel
    */
    cancel () {
      this.reset()
      this.$emit('canceled')
    },
    /**
     * Handle changed nfse file
     */
    changeNFSeFile (e) {
      const file = e.target.files[0]
      this.form.nfse_file = file
    },
    /**
     * Reset
    */
    reset () {
      this.form.amount = 0
      this.form.nfse_issuance_date = ''
      this.form.nfse_amount = 0
      this.form.nfse_description = ''
      this.form.nfse_amount = null
      this.form.payment_expiration_date = ''
      this.form.payment_method = ''
    },
    /**
     * Submit form
    */
    async submit () {
      this.loader = true
      try {
        const form = Object.assign({}, this.form)
        form.should_issue_nfse = this.should_issue_nfse === 'S' ? 1 : 0
        form.nfse_amount = form.nfse_amount * 100
        form.amount = form.amount * 100
        const order = await OrdersService.updateOrder(this.localOrder.id, form)
        this.localOrder = order
        this.$emit('updated', order)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
